<template>
  <div>
    <h4>You are at furnace process page.</h4>

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <!--              <vs-dropdown-item>-->
              <!--                <span class="flex items-center">-->
              <!--                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />-->
              <!--                  <span>Delete</span>-->
              <!--                </span>-->
              <!--              </vs-dropdown-item>-->

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="order_no">Order No</vs-th>
        <vs-th sort-key="item_code">Item Code</vs-th>
        <vs-th sort-key="batch_no">Batch No</vs-th>
        <vs-th sort-key="operation">Operation</vs-th>
        <vs-th sort-key="work_center">Work Center</vs-th>
        <vs-th sort-key="time_start">Start</vs-th>
        <vs-th sort-key="time_end">End</vs-th>
        <vs-th sort-key="output_quantity">Output</vs-th>
        <vs-th sort-key="off_spec">Off-Spec</vs-th>
        <vs-th sort-key="qc_sample">QC Sample</vs-th>
        <vs-th sort-key="drum_num_from">Drums</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <router-link :to="'/process/roller/'+tr.order_no">
              <p class="product-name font-medium">{{ tr.order_no }}</p>
            </router-link>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ tr.item_code }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.batch_no }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.operation.toUpperCase() }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">{{ tr.work_center }}</p>
          </vs-td>

          <vs-td>
            <p>{{ tr.time_start || '-' }}</p>
          </vs-td>
          <vs-td>
            <p>{{ tr.time_end || '-' }}</p>
          </vs-td>

          <vs-td>
            <p>{{ tr.output_quantity || '-' }} kg</p>
          </vs-td>

          <vs-td>
            <p>{{ tr.off_spec || '-' }} kg</p>
          </vs-td>
          <vs-td>
            <p>{{ tr.qc_sample || '-' }} kg</p>
          </vs-td>
          <vs-td>
            <p>{{ tr.drum_num_from + ' - ' + tr.drum_num_to }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            <!--            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selected: [],
      products: [],
      itemsPerPage: 25,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    fetchMaterials () {
      this.$http.get('/api/process/roller')
        .then(items => {
          this.products = items.data.order
        })
    },
    addNewData () {
      this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    // deleteData (id) {
    //   this.$store.dispatch('dataList/removeItem', id).catch(err => {
    //     console.error(err)
    //   })
    // },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      // this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    }
  },
  mounted () {
    this.isMounted = true
    this.fetchMaterials()
  }

}
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
